var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 310,
    viewBox: "0 0 280 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.67 286.244L142.914 235.328C156.904 243.805 168.363 249.559 177.4 252.492C183.521 254.478 188.792 255.261 193.099 254.521C197.569 253.752 200.901 251.346 202.857 247.366C204.73 243.555 205.246 238.506 204.772 232.496C204.296 226.442 202.791 219.137 200.359 210.621C198.559 204.326 196.24 197.318 193.42 189.606C197.846 197.265 202.01 204.001 205.927 209.792C211.002 217.294 215.709 223.281 220.085 227.652C224.426 231.991 228.633 234.938 232.734 236.033C237.033 237.18 241.006 236.229 244.422 233.276C247.692 230.447 250.368 225.866 252.634 219.855C255.799 211.461 258.365 199.728 260.455 184.636L268.024 250.434L189.67 286.244Z",
    fill: "#470086"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.058 302.03L152.301 251.114C166.291 259.592 177.75 265.345 186.788 268.279C192.908 270.265 198.179 271.048 202.486 270.308C206.957 269.539 210.288 267.133 212.244 263.153C214.118 259.341 214.634 254.293 214.159 248.282C213.683 242.229 212.179 234.924 209.747 226.408C207.946 220.112 205.627 213.105 202.807 205.392C207.233 213.052 211.397 219.787 215.314 225.579C220.389 233.08 225.096 239.067 229.472 243.439C233.813 247.777 238.02 250.724 242.122 251.819C246.42 252.967 250.394 252.016 253.809 249.062C257.079 246.233 259.755 241.652 262.021 235.641C265.186 227.248 267.753 215.515 269.842 200.422L277.411 266.22L199.058 302.03Z",
    stroke: "#F5A623",
    strokeWidth: 1.66,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.6d79ccd02514bf96e41bd8b126c92137.svg";
export { ForwardRef as ReactComponent };